module.exports = __webpack_public_path__ + "img/ae27d3f818f3f2011c739c5b2d199c1b.svg";